export enum UserRoleEnum {
    individual,
    startUp,
    enterprise,
}
